import { ApiError, apiExchange } from '../api/client'

/**
 * Butonul PDF al listei (`pdfHtml5` din portal): capul si randurile vizibile
 * pleaca la `POST /api/v2/export/list.pdf`, iar serverul le aseaza in pagina
 * cu html2pdf (`ListPdfController`). Cand serverul n-are motorul, raspunde
 * 501 cu o propozitie, si aia se arata - nu se salveaza un fisier care nu e
 * un PDF.
 */
export async function downloadListPdf(rows: string[][], title: string): Promise<void> {
  const [head = [], ...body] = rows
  const out = await apiExchange('/export/list.pdf', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ title, head, rows: body }),
  })

  if (!out.type.includes('pdf')) {
    let message = 'The PDF could not be produced.'
    try {
      message = (JSON.parse(out.text) as { message?: string }).message ?? message
    } catch {
      /* Raspunsul nu era JSON; ramane propozitia de mai sus. */
    }
    throw new ApiError(out.status || 501, message)
  }

  const blob = new Blob([out.bytes], { type: 'application/pdf' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = out.filename || (title.trim() || 'list').replace(/[\\/:*?"<>|]+/g, ' ').trim() + '.pdf'
  document.body.appendChild(a)
  a.click()
  a.remove()
  window.setTimeout(() => URL.revokeObjectURL(url), 1000)
}
